/* eslint-disable */

/** unique or primary key constraints on table "argo.material_class" */
export enum ArgoMaterialClassConstraint {
  /** unique or primary key constraint on columns "context_id", "name" */
  MaterialClassContextIdName = 'material_class_context_id_name',
  /** unique or primary key constraint on columns "context_id", "is_default" */
  MaterialClassIsDefaultCnstrnt = 'material_class_is_default_cnstrnt',
  /** unique or primary key constraint on columns "material_class_id" */
  MaterialClassPkey = 'material_class_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  MaterialClassUnique = 'material_class_unique'
}

/** select columns of table "argo.material_class" */
export enum ArgoMaterialClassSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LinkedMedia = 'linked_media',
  /** column name */
  LinkedProfilePicture = 'linked_profile_picture',
  /** column name */
  MaterialQuantityType = 'material_quantity_type',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  SnValidationPattern = 'sn_validation_pattern',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.material_class" */
export enum ArgoMaterialClassUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LinkedMedia = 'linked_media',
  /** column name */
  LinkedProfilePicture = 'linked_profile_picture',
  /** column name */
  MaterialQuantityType = 'material_quantity_type',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  SnValidationPattern = 'sn_validation_pattern',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

